// React
import React from 'react';

// Style
import './style.sass';

class LeftHexSecondHome extends React.Component {
  render() {
    return (
      <div className='left-hex-second-home-wrapper'>
        <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 428 654'>
          <defs>
            <radialGradient
              id='radial-gradient'
              cx='.5'
              cy='.5'
              r='.5'
              gradientUnits='objectBoundingBox'
            >
              <stop offset='0' stopColor='#215274' stopOpacity='.851' />
              <stop offset='1' stopColor='#215274' stopOpacity='0' />
            </radialGradient>
            <clipPath id='clip-path'>
              <path
                id='Rectángulo_117'
                data-name='Rectángulo 117'
                transform='translate(0 789)'
                style={{ fill: '#fff', stroke: '#707070' }}
                d='M0 0h428v654H0z'
              />
            </clipPath>
            <style></style>
          </defs>
          <g id='Grupo_361' data-name='Grupo 361' transform='translate(0 -769)'>
            <g
              id='Grupo_359'
              data-name='Grupo 359'
              transform='translate(0 770.363)'
              style={{ opacity: '.15' }}
            >
              <path
                id='Trazado_2925'
                data-name='Trazado 2925'
                className='cls-3'
                d='M116.194 141.53 84.6 196.242l31.589 54.712h63.181l31.589-54.712-31.589-54.712zm61.339 106.243h-59.5l-29.751-51.53 29.751-51.53h59.5l29.753 51.53z'
                transform='translate(158.919 389.683)'
              />
              <path
                id='Trazado_2927'
                data-name='Trazado 2927'
                className='cls-3'
                d='M84.605 719.788v3.182h62.258l30.669-53.121h59.509l30.669 53.12h63.176l31.589-54.712-31.591-54.711h-61.337l-29.753-51.531 29.751-51.53h59.5l30.669 53.121h63.176l31.589-54.714-30.669-53.118 30.669-53.121-31.585-54.713h-63.176l-30.669 53.12h-59.5l-29.751-51.529 30.671-53.121-31.593-54.71H175.7l-30.668 53.118H84.605V298h60.421l29.751 51.529-29.751 51.532H84.605v3.182h60.424l29.753 51.534-30.669 53.118 30.669 53.123-29.751 51.531H84.605v3.182h60.421l29.751 51.53-29.751 51.53zm274.2-51.532-29.75 51.53h-59.5L239.8 668.258l29.75-51.53h59.5zm0-212.483-29.76 51.527h-59.5L239.8 455.774l29.75-51.532h59.5zm62.258 104.65h-59.5L331.806 508.9l29.751-51.532h59.5l29.751 51.527zm-59.5-209.3h59.5l29.753 51.531-29.751 51.529h-59.5L331.8 402.649zM177.538 244.879h59.5l29.75 51.53-29.75 51.53h-59.5l-29.751-51.53zm0 106.243h59.5l29.75 51.531-29.748 51.529h-59.504l-29.75-51.529zm0 106.243h59.506l29.748 51.527-29.75 51.532h-59.5l-29.751-51.532zm0 106.241h59.5l29.75 51.53-29.75 51.531h-59.5l-29.751-51.531z'
                transform='translate(-84.605 -241.697)'
              />
            </g>
            <g
              id='Enmascarar_grupo_53'
              data-name='Enmascarar grupo 53'
              transform='translate(0 -20)'
              style={{ clipPath: 'url(#clip-path)' }}
            >
              <ellipse
                id='Elipse_74'
                data-name='Elipse 74'
                cx='276.21'
                cy='376.301'
                rx='276.21'
                ry='376.301'
                transform='scale(-1) rotate(-52.32 -1417.025 -3.18)'
                style={{ opacity: '.8', fill: 'url(#radial-gradient)' }}
              />
            </g>
          </g>
        </svg>
      </div>
    );
  }
}

export default LeftHexSecondHome;
